module.exports = __webpack_public_path__ + "static/media/sax-min.e5a9800c.png";